import React, { useMemo } from 'react';
import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { IGameWinsCoefsSectionProps } from '../types';
import { preparePragmaticGameResults } from './utils';

import styles from './index.module.css';

const GameWinsCoefsSection: React.FC<IGameWinsCoefsSectionProps> = ({
  pragmaticInstantData
}) => {
  const gameResultsPrepared = useMemo(
    () => preparePragmaticGameResults(pragmaticInstantData?.results),
    [pragmaticInstantData]
  );

  return (
    <Box align="center" className={styles.gameWinsCoefsContainer}>
      {gameResultsPrepared.map(({ winCoef, coefSize, id }) => (
        <Box
          key={id}
          className={clsx([
            styles.singleWinCoefBlock,
            styles[`singleWinCoefBlock_${coefSize}`]
          ])}
        >
          <AText breed="B" className={styles.coefText}>
            {winCoef}
          </AText>
        </Box>
      ))}
    </Box>
  );
};

export default GameWinsCoefsSection;
